import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../../routes';
import routeConstant from '../../../constants/route.constants';
import GraphButton from '../../GraphButton';
import { cleanUpState } from '../scripts/tree-slice';
import { useDispatch } from 'react-redux';

const FullscreenBtn = () => {
  const dispatch = useDispatch();
  const [isFullPage, setFullPage] = React.useState(false);
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    const currentRoute = routes.find((route) => route.path?.includes(location.pathname));
    // // debug-console.log('currentRoute=' + currentRoute.path);
    if (currentRoute) {
      setFullPage(currentRoute.isFullPage);
      // // debug-console.log('setFullPage=' + currentRoute.isFullPage);
    }
  }, []);

  if (isFullPage)
    return (
      <GraphButton
        id="fullscreen"
        label="Exit Full Screen"
        onClick={() => {
          dispatch(cleanUpState());
          history.push(routeConstant.DASH_BOARD);
        }}
        title="Thoát chế độ Xem toàn màn hình"
      />
    );

  return (
    <GraphButton
      id="fullscreen"
      label="Full Screen"
      onClick={() => {
        dispatch(cleanUpState());
        history.push(routeConstant.FULL_TREE);
      }}
      title="Xem toàn màn hình"
    />
  );
};

export default FullscreenBtn;
